import { render, staticRenderFns } from "./LandingPrices.vue?vue&type=template&id=765859db&scoped=true&"
import script from "./LandingPrices.vue?vue&type=script&lang=js&"
export * from "./LandingPrices.vue?vue&type=script&lang=js&"
import style0 from "./LandingPrices.vue?vue&type=style&index=0&id=765859db&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765859db",
  null
  
)

/* custom blocks */
import block0 from "./LandingPrices.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./LandingPrices.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
